import { render, staticRenderFns } from "./MonitoringStudents.vue?vue&type=template&id=1b6b1d86&"
import script from "./MonitoringStudents.vue?vue&type=script&lang=js&"
export * from "./MonitoringStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports